import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=fc48f784&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=fc48f784&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc48f784",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc48f784')) {
      api.createRecord('fc48f784', component.options)
    } else {
      api.reload('fc48f784', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=fc48f784&scoped=true&", function () {
      api.rerender('fc48f784', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2mvkpnBfAgwUw/JS/comp/SearchFilterTokens.vue"
export default component.exports